import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import parsePhoneNumber from 'libphonenumber-js';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';

const DinerInformationReadOnlyField = styled(Typography)({ fontSize: '16px' });

const DinerInformationReadOnly = () => {
  const { dinerEmail, dinerName, dinerPhone, formattedDinerPhone } =
    useDinerAccount();
  const { setValue } = useFormContext();
  const parsedPhone = parsePhoneNumber(dinerPhone);

  useEffect(() => {
    setValue('email', dinerEmail);
    setValue('fullPhoneNumber', dinerPhone);
    setValue('name', dinerName);
    setValue('phone', parsedPhone?.nationalNumber);
    setValue('phoneCode', parsedPhone?.countryCallingCode);
  }, []);

  return (
    <>
      <DinerInformationReadOnlyField>{dinerName}</DinerInformationReadOnlyField>
      <DinerInformationReadOnlyField>
        {dinerEmail}
      </DinerInformationReadOnlyField>
      <DinerInformationReadOnlyField>
        {formattedDinerPhone}
      </DinerInformationReadOnlyField>
    </>
  );
};

export default DinerInformationReadOnly;
